require('./lbaRouteRoot.scss');

const lbaRouteRoot = angular.module('app.lbaRouteRoot', []);

lbaRouteRoot.component('lbaRouteRoot', {
  bindings: {
    target: '<'
  },
  controllerAs: 'vm',
  controller: ['$rootScope', '$routeParams', 'settingsService', lbaRouteRootCtrl],
  template: `
<div lba-nav target="vm.target"></div>

<div lba-loader show-loader="vm.showLoader"></div>

<div class="lbaContainer">
        <lba-bread-crumb></lba-bread-crumb>
        <div class="lbaContainer_nav">
          <div ng-if="$root.showSubNav">
          <lba-sub-nav></lba-sub-nav>
          </div>
        </div>
        <div class="lbaContainer_fields">
          <div class="lbaContainer_content">
            <div lba-dynamic="'lba-' + vm.settings[vm.target].displayAs" settings="vm.settings[vm.target]"></div>
          </div>
        </div>
</div>`
});

function lbaRouteRootCtrl($rootScope, $routeParams, settingsService) {
  let vm = this;
  vm.routeParams = $routeParams;
  settingsService.settings = settingsService.get();
  vm.settings = settingsService.settings;

  if (vm.settings[vm.target].rootNode) {
    $rootScope.showSubNav = false;
  }
}

export default lbaRouteRoot;


// WEBPACK FOOTER //
// ./src/components/lbaRouteRoot/lbaRouteRoot.js